import { NavLink } from 'react-router-dom';

/**
 * Меню профиля в стиле масобр: имя видно снаружи, «Выйти» внутри выпадашки.
 */
export default function UserAccountMenu({ user, onLogout }) {
  if (!user) return null;

  return (
    <details className="account-menu">
      <summary className="account-menu-toggle" aria-label="Меню профиля">
        <span className="account-menu-avatar" aria-hidden>
          👤
        </span>
        <span className="account-menu-username">{user.username}</span>
      </summary>
      <div className="account-menu-dropdown">
        <NavLink to="/profile" className="account-menu-item">
          Профиль
        </NavLink>
        {user.is_student && (
          <NavLink to="/questionnaire" className="account-menu-item">
            {user.has_questionnaire ? 'Анкета' : 'Заполнить анкету'}
          </NavLink>
        )}
        {!user.is_teacher && (
          <NavLink to="/billing" className="account-menu-item">
            Баланс и оплата
          </NavLink>
        )}
        <button type="button" className="account-menu-item account-menu-logout" onClick={onLogout}>
          Выйти
        </button>
      </div>
    </details>
  );
}
